var _rect, _rect2, _path, _circle, _ellipse, _circle2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadersvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 203,
    viewBox: "0 0 701 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 196.571,
    width: 101,
    height: 9,
    transform: "rotate(-65.046 0 196.571)",
    fill: "#53CBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 272.573,
    y: 179.826,
    width: 101,
    height: 9,
    transform: "rotate(-128.87 272.573 179.826)",
    fill: "#F5DC54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.874 96.8519L485.112 120.981L438.979 161.632L422.874 96.8519Z",
    fill: "#F5DC54"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 441.962,
    cy: 80.6993,
    r: 17.5,
    transform: "rotate(-41.3846 441.962 80.6993)",
    fill: "#F5DC54"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.5,
    cy: 180,
    rx: 22.5,
    ry: 23,
    fill: "#F5DC54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.752,
    cy: 19.7727,
    r: 15,
    transform: "rotate(-23.7664 675.752 19.7727)",
    fill: "#53CBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 604.702,
    y: 71.8203,
    width: 101,
    height: 9,
    transform: "rotate(-23.7664 604.702 71.8203)",
    fill: "#53CBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 81,
    width: 54,
    height: 57,
    fill: "#53CBFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 138,
    width: 54,
    height: 57,
    fill: "#F5DC54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadersvg);
export default __webpack_public_path__ + "static/media/headersvg.456ab339f36d94665c17f1d303a37d42.svg";
export { ForwardRef as ReactComponent };